var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-form"},[_c('s-field',{staticClass:"is-tiny-v alt-form-style s-duration"},[_c('s-input',{attrs:{"type":"text","append":"h"}})],1),_vm._v(" "),_c('s-field',{staticClass:"is-tiny-v alt-form-style s-duration"},[_c('s-input',{attrs:{"type":"text","append":"m"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }